<script>
  import { getIndexByAttr, getByAttr } from "../helper/ListExtensions";
  import {
    RadioGroup,
    Card,
    Button,
    Radio,
    Input,
    Textarea
  } from "../components/ui";
  import { Modal } from "../components/display";

  import { getBenefitsList } from "../helper/TextGenerator";

  import Icon from "svelte-awesome";
  import {
    faCheck,
    faPen,
    faPlusCircle
  } from "@fortawesome/free-solid-svg-icons";
  import BenefitEdit from "./Benefit_Edit.svelte";

  export let model;

  //   let selectedItems = {
  //     pains: [],
  //     gains: [],
  //     jobs: [],
  //     features: []
  //   };

  let activeBenefitIndex = 0;
    let showEdit = false;
  //let tmpBenefits = [];
  //let selectedBenefitIndex;
  //let benefits = [];

  //   async function itemSelected(item, group) {
  //     let index;
  //     if (selectedItems[group] != null)
  //       index = getIndexByAttr(selectedItems[group], "value", item.value);
  //     if (index > -1) selectedItems[group].splice(index, 1);
  //     else selectedItems[group].push(item);

  //     getBenefitsList(selectedItems, model.document)
  //       .then(result => {
  //         tmpBenefits = result;
  //       })
  //       .catch(err => {
  //         console.log(`Error getBenefitsList: ${err}`);
  //       });
  //   }

  //   let benefitVal = 0;
  //   const createBenefit = () => {
  //     let newItem = getByAttr(tmpBenefits, "value", selectedBenefitIndex);
  //     newItem["value"] = `benefit_${benefitVal}`;
  //     // newItem['basedOn'] = JSON.parse(JSON.stringify(selectedItems)); //We need a deep copy here to not update existing values
  //     //TODO build basedOn Index for better handling of value change in cloud function
  //     model.benefits.items = [...model.benefits.items, newItem].reverse();

  //     selectedBenefitIndex = null;
  //     benefitVal++;
  //   };
  let benefitVal = 0;
  const addNew = function(index) {
    let newItem = {
      text: null,
      sortPos: model.benefits.items.length,
      value: `benefit_${benefitVal}`,
      basedOn: null
    };
    model.benefits.items = [...model.benefits.items, newItem];
    activeBenefitIndex = newItem.sortPos;
    showEdit = true;
    benefitVal++;
  };
</script>

<div class="overflow-auto">
  {#each model.benefits.items as benefit, i (benefit.value)}
    <div class="border-main rounded border-4 p-4 mt-4" on:click={()=>{activeBenefitIndex = i; showEdit = true;}}>
      <p class="text-2xl">{benefit.text}</p>
      {#if benefit.basedOn != null}
      {#each benefit.basedOn.pains as pain (pain.text)}
        <div class="flex-row flex mt-2 mb-2">
          <div class="px-3 py-1 bg-gray-400 ml-2 mr-2 text-xs rounded">
            Pain
          </div>
          {pain.text}
        </div>
      {/each}
      {#each benefit.basedOn.gains as gain}
        <div class="flex-row flex mt-2 mb-2">
          <div class="px-3 py-1 bg-gray-400 ml-2 mr-2 text-xs rounded">
            Gain
          </div>
          {gain.text}
        </div>
      {/each}
      {#each benefit.basedOn.jobs as job}
        <div class="flex-row flex mt-2 mb-2">
          <div class="px-3 py-1 bg-gray-400 ml-2 mr-2 text-xs rounded">Job</div>
          {job.text}
        </div>
      {/each}
      {#each benefit.basedOn.features as feature}
        <div class="flex-row flex mt-2 mb-2">
          <div class="px-3 py-1 bg-gray-400 ml-2 mr-2 text-xs rounded">
            Feature
          </div>
          {feature.text}
        </div>
      {/each}
      {/if}
    </div>
  {/each}
  <div
    class="w-1/3 float-left opacity-50 hover:opacity-100 cursor-pointer"
    style="height:410px">
    <Card class="p-4 h-full text-center">
      <button type="button" on:click={addNew} style="margin-top:157px">
        <Icon data={faPlusCircle} scale="3" />
      </button>
    </Card>
  </div>
</div>
{#if showEdit}
<Modal>
  <BenefitEdit bind:model={model.benefits.items[activeBenefitIndex]} data={model} on:save={()=>{showEdit = false}} />
</Modal>
{/if}

